const isDev = process.env.NODE_ENV === 'development'

//קבצי מדיה שהוחלפו בשם זהה: {נתיב: גרסה} (השרת: DTechComp/mediaVersions.js, מגיע עם המאסטר).
//נשמר גם בדפדפן, כדי שכבר ברינדור הראשון בכניסה הבאה הכתובות יהיו עם הגרסה
const MEDIA_V_KEY = "amMediaV";
let mediaVersions = {};
try { mediaVersions = JSON.parse(localStorage.getItem(MEDIA_V_KEY)) || {}; } catch (e) { }

class ConnUrls {
    //כתובת מלאה של קובץ מדיה. קבצים נשמרים בדפדפן לזמן ארוך, ולקובץ שהוחלף מתווסף ?v=
    static media(path) {
        let v = path ? mediaVersions[path] : undefined;
        if (v === undefined && path) {
            try { v = mediaVersions[decodeURIComponent(path)]; } catch (e) { }
        }
        return `${ConnUrls.servMediasUrl}${path}${v ? `?v=${v}` : ''}`;
    }

    static setMediaVersions(map) {
        if (!map || typeof map !== 'object') return;
        mediaVersions = map;
        try { localStorage.setItem(MEDIA_V_KEY, JSON.stringify(map)); } catch (e) { }
    }

    static ApiUrl = isDev ? 'http://localhost:8000/api/' : 'https://api.ashdodmenu.co.il/api/';
    static mediasUrl = isDev ? 'http://localhost:3000' : 'https://api.ashdodmenu.co.il';
    static mediasLocalUrl = isDev ? 'http://localhost:4001' : 'https://admin.ashdodmenu.co.il';
    // static servMediasUrl = isDev ? 'http://localhost:8000/images/' : 'https://api.ashdodmenu.co.il/images/';
    static servMediasUrl = 'https://am-medias.s3.eu-central-1.amazonaws.com/images/';
    static socketClient = isDev ? 'http://localhost:9000/' : 'https://socket.ashdodmenu.co.il/';


    // static siteDomainNam = isDev ? 'http://localhost:3000' :`https://www.ashdodmenu.co.il`

    // // static ApiUrl = isDev ? 'http://192.168.1.105:8000/api/' : 'https://api.ashdodmenu.co.il/api/';
    // // static mediasUrl = isDev ? 'http://192.168.1.105:3000' : 'https://api.ashdodmenu.co.il';
    // // static mediasLocalUrl = isDev ? 'http://192.168.1.105:4001' : 'https://admin.ashdodmenu.co.il';
    // // // static servMediasUrl = isDev ? 'http://192.168.1.105:8000/images/' : 'https://api.ashdodmenu.co.il/images/';
    // // static servMediasUrl = 'https://am-medias.s3.eu-central-1.amazonaws.com/images/';
    // // static socketClient = isDev ? 'http://192.168.1.105:9000/' : 'https://socket.ashdodmenu.co.il/';



    
    // static ApiUrl = isDev ? 'http://192.168.1.111:8000/api/' : 'https://api.ashdodmenu.co.il/api/';
    // static mediasUrl = isDev ? 'http://192.168.1.111:3000' : 'https://api.ashdodmenu.co.il';
    // static mediasLocalUrl = isDev ? 'http://192.168.1.111:4001' : 'https://admin.ashdodmenu.co.il';
    // // static servMediasUrl = isDev ? 'http://localhost:8000/images/' : 'https://api.ashdodmenu.co.il/images/';
    // static servMediasUrl = 'https://am-medias.s3.eu-central-1.amazonaws.com/images/';
    // static socketClient = isDev ? 'http://192.168.1.111:9000/' : 'https://socket.ashdodmenu.co.il/';
}
export default ConnUrls;